<div class="app-container" [class.is-mobile]="mobileQuery.matches">
  <mat-toolbar color="primary" class="app-toolbar toolbar-dense">
    <div class="app-toolbar-sections">
      <!-- Start: Hamburger + Title -->
      <div class="app-toolbar-start">
        <button mat-icon-button (click)="mainSideNav.toggle()"><mat-icon>menu</mat-icon></button>
        <span *ngIf="!selectedEcommerceOrder" class="app-toolbar-title" i18n="@@Ecommerce Orders">Ecommerce Orders</span>
        <!-- Deliberately NOT `[disabled]="editingOrder"`. A control that is visibly
             present, does nothing when clicked, and says nothing about why teaches the
             operator only that the button is broken. goBackToOrders() asks the question
             instead and offers both answers. -->
        <button *ngIf="selectedEcommerceOrder" mat-icon-button (click)="goBackToOrders()" i18n-title="@@Back To Orders" title="Back To Orders">
          <mat-icon style="color: white;">{{startupService.dir === 'rtl' ? 'arrow_forward_ios' : 'arrow_back_ios'}}</mat-icon>
        </button>
        <span *ngIf="selectedEcommerceOrder" class="app-toolbar-title">{{ selectedEcommerceOrder.remoteOrderId }}</span>
      </div>

      <!-- Center: Store selector + Filters + Search + Labels toggle + Actions (browsing mode) -->
      <div class="app-toolbar-center" *ngIf="!selectedEcommerceOrder">
        <!-- Ecommerce store selector -->
        <ng-container *ngIf="ecommerceConnections && ecommerceConnections.length > 1">
          <div class="toolbar-store-select">
            <mat-icon class="toolbar-store-icon">store</mat-icon>
            <span class="toolbar-btn-label toolbar-store-label" i18n="@@Store">Store</span>
            <select class="toolbar-native-select"
                    [ngModel]="selectedEcommerceConnectionId"
                    (ngModelChange)="onStoreSelectChange($event)"
                    i18n-title="@@Select Ecommerce Store" title="Select Ecommerce Store">
              <option value="ALL" i18n="@@All Stores">All Stores</option>
              <!-- `storeLabel` -- see EcommerceConnection.storeLabel: several stores of one type per organization is normal. -->
              <option *ngFor="let ec of ecommerceConnections" [value]="ec.ID">{{ ec.type | languageString }} {{ ec.storeLabel }} - {{ ( organizationService && organizationService.objectsById['' + ec.org_ID]) ? organizationService.objectsById['' + ec.org_ID].name : 'Org ' + ec.org_ID }}</option>
            </select>
          </div>
        </ng-container>

        <div class="toolbar-divider"></div>

        <!-- Filter toggles -->
        <div class="toolbar-filters">
          <button class="toolbar-filter" [class.active]="selectedFilters.value.includes('ALL')" (click)="toggleFilter('ALL')" i18n-title="@@All" title="All">
            <mat-icon>filter_list</mat-icon><span class="toolbar-btn-label" i18n="@@All">All</span>
          </button>
          <button class="toolbar-filter" [class.active]="selectedFilters.value.includes('NEED_ATTENTION')" (click)="toggleFilter('NEED_ATTENTION')" i18n-title="@@Need Attention" title="Need Attention">
            <mat-icon>warning</mat-icon><span class="toolbar-btn-label" i18n="@@Need Attention">Need Attention</span>
          </button>
          <button class="toolbar-filter" [class.active]="selectedFilters.value.includes('READY_TO_RELEASE')" (click)="toggleFilter('READY_TO_RELEASE')" i18n-title="@@Ready to Release" title="Ready to Release">
            <mat-icon>check_circle</mat-icon><span class="toolbar-btn-label" i18n="@@Ready to Release">Ready to Release</span>
          </button>
          <button class="toolbar-filter" [class.active]="selectedFilters.value.includes('PROCESSING')" (click)="toggleFilter('PROCESSING')" i18n-title="@@Processing" title="Processing">
            <mat-icon>hourglass_empty</mat-icon><span class="toolbar-btn-label" i18n="@@Processing">Processing</span>
          </button>
          <button class="toolbar-filter" [class.active]="selectedFilters.value.includes('RELEASED')" (click)="toggleFilter('RELEASED')" i18n-title="@@Released" title="Released">
            <mat-icon>send</mat-icon><span class="toolbar-btn-label" i18n="@@Released">Released</span>
          </button>
          <!-- Membership is decided by matchesShippedFilter(), NOT by isShipped(). The two
               deliberately differ on the UNKNOWN case: a row colour and an action button must
               fail closed when the fulfilments cannot be seen, but a filter that fails closed
               silently drops an order that HAS shipped out of the one list meant to contain
               it, with nothing on screen to say why. -->
          <button class="toolbar-filter" [class.active]="selectedFilters.value.includes('SHIPPED')" (click)="toggleFilter('SHIPPED')" i18n-title="@@Shipped" title="Shipped">
            <mat-icon>local_shipping</mat-icon><span class="toolbar-btn-label" i18n="@@Shipped">Shipped</span>
          </button>
          <button class="toolbar-filter" [class.active]="selectedFilters.value.includes('ON_HOLD')" (click)="toggleFilter('ON_HOLD')" i18n-title="@@On Hold" title="On Hold">
            <mat-icon>pause_circle</mat-icon><span class="toolbar-btn-label" i18n="@@On Hold">On Hold</span>
          </button>
          <button class="toolbar-filter" [class.active]="selectedFilters.value.includes('IGNORED')" (click)="toggleFilter('IGNORED')" i18n-title="@@Ignored" title="Ignored">
            <mat-icon>cancel</mat-icon><span class="toolbar-btn-label" i18n="@@Ignored">Ignored</span>
          </button>
        </div>

        <!-- Show/Hide Labels standalone toggle -->
        <button class="toolbar-filter-standalone" [class.active]="showSymbolMeanings" (click)="showSymbolMeanings=!showSymbolMeanings" [title]="showSymbolMeanings ? 'Hide Labels' : 'Show Labels'">
          <mat-icon>{{ showSymbolMeanings ? 'label' : 'label_off' }}</mat-icon>
        </button>

        <div class="toolbar-divider"></div>

        <!-- Search -->
        <div class="toolbar-search">
          <mat-icon>search</mat-icon>
          <input type="text" (keyup)="onSearchInputChange($event)" i18n-placeholder="@@Search" placeholder="Search">
        </div>

        <div class="toolbar-divider"></div>

        <!-- Actions -->
        <div class="toolbar-actions">
          <button *ngIf="sortStack.length > 0" class="toolbar-action" (click)="clearSort()" i18n-title="@@Clear Sort" title="Clear Sort">
            <mat-icon>sort</mat-icon><span class="toolbar-btn-label" i18n="@@Clear Sort">Clear Sort</span>
          </button>
          <button *ngIf="selectedEcommerceConnection && selectedEcommerceConnection.type !== 'CSV'" class="toolbar-action toolbar-action-primary" (click)="readRemoteOrders($event)" i18n-title="@@Read Remote Orders" title="Read Remote Orders">
            <mat-icon>cloud_download</mat-icon><span class="toolbar-btn-label" i18n="@@Read Remote Orders">Read Remote Orders</span>
          </button>
        </div>
      </div>

      <!-- End -->
      <div class="app-toolbar-end">
        <app-shopping-cart-top-bar-button></app-shopping-cart-top-bar-button>
        <app-active-role></app-active-role>
      </div>
    </div>
  </mat-toolbar>
  <mat-sidenav-container class="app-sidenav-container" (backdropClick)="mainSideNav.close()" [style.marginTop.px]="mobileQuery.matches ? 56 : 0">
    <mat-sidenav opened #mainSideNav [mode]="mobileQuery.matches ? 'over' : 'side'" (keydown.escape)="mainSideNav.close()" [fixedInViewport]="mobileQuery.matches" fixedTopGap="56">
      <mat-nav-list>
        <app-side-nav focus="ecommerceorders"></app-side-nav>
      </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav-content class="m2app-dark">
      <div class="app-content">
        <div *ngIf="!selectedEcommerceOrder" class="pageArea">

          <div class="summary">
            <div class="summary-container">
              <div class="summary-week-selector">
                <mat-form-field appearance="outline" class="summary-week-field">
                  <mat-label i18n="@@Select Week">Select Week</mat-label>
                  <mat-select [value]="selectedWeek" (selectionChange)="onWeekChange($event)">
                    <mat-option *ngFor="let week of weekOptions" [value]="week.value">{{ week.viewValue }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="summary-cards">
                <div class="summary-card">
                  <mat-icon class="summary-card-icon">receipt_long</mat-icon>
                  <div class="summary-card-data">
                    <span class="summary-value">{{ ordersCount$ | async }}</span>
                    <span class="summary-title" i18n="@@Orders">Orders</span>
                  </div>
                </div>
                <div class="summary-card">
                  <mat-icon class="summary-card-icon">inventory_2</mat-icon>
                  <div class="summary-card-data">
                    <span class="summary-value">{{ orderItemsCount$ | async }}</span>
                    <span class="summary-title" i18n="@@Order Items">Order Items</span>
                  </div>
                </div>
                <div class="summary-card summary-card-success">
                  <mat-icon class="summary-card-icon">local_shipping</mat-icon>
                  <div class="summary-card-data">
                    <span class="summary-value">{{ ordersShippedCount$ | async }}</span>
                    <span class="summary-title" i18n="@@Shipped">Shipped</span>
                  </div>
                </div>
                <div class="summary-card summary-card-warn">
                  <mat-icon class="summary-card-icon">pause_circle</mat-icon>
                  <div class="summary-card-data">
                    <span class="summary-value">{{ ordersHoldCount$ | async }}</span>
                    <span class="summary-title" i18n="@@On Hold">On Hold</span>
                  </div>
                </div>
                <div class="summary-card summary-card-alert">
                  <mat-icon class="summary-card-icon">monetization_on</mat-icon>
                  <div class="summary-card-data">
                    <span class="summary-value">{{ ordersCostReviewCount$ | async }}</span>
                    <span class="summary-title" i18n="@@Cost Review">Cost Review</span>
                  </div>
                </div>
                <div class="summary-card summary-card-alert">
                  <mat-icon class="summary-card-icon">rate_review</mat-icon>
                  <div class="summary-card-data">
                    <span class="summary-value">{{ ordersNeedReviewCount$ | async }}</span>
                    <span class="summary-title" i18n="@@Needs Review">Needs Review</span>
                  </div>
                </div>
                <div class="summary-card">
                  <mat-icon class="summary-card-icon">request_quote</mat-icon>
                  <div class="summary-card-data">
                    <span class="summary-value">{{ totalProductionCostShippedDelivered$ | async }}</span>
                    <span class="summary-title" i18n="@@Unreleased Cost">Unreleased Cost</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="mainOrdersArea">

            <!-- templates used by both the table and the narrow stacked div element versions -->
            <!-- 'ecommerceConnection', 'order', 'date', 'status', 'customer', 'items', 'storeRevenue', 'totalCost', 'tracking', 'details', 'actions'-->

            <!-- Sort indicator: arrow shows the direction, the number shows the position in the multi-column sort -->
            <ng-template #sortIndicatorTemplate let-column>
              <span class="sort-indicator" [class.sort-active]="getSortDirection(column)">
                <mat-icon class="sort-arrow">{{ getSortDirection(column) === 'desc' ? 'arrow_downward' : 'arrow_upward' }}</mat-icon>
                <span class="sort-priority" *ngIf="getSortPriority(column) > 0 && sortStack.length > 1">{{ getSortPriority(column) | numberFormat }}</span>
              </span>
            </ng-template>

            <ng-template #ecommerceConnectionTemplate let-row>
              <div>{{ row.ecommerceConnection.type | languageString }} {{row.ecommerceConnection.ID}}</div>
              <div><span *ngIf="showSymbolMeanings">{{ 'Organization' | languageString }}:&nbsp;</span>{{ row.ecommerceConnection.org_ID }}: {{ ( organizationService && organizationService.objectsById['' + row.ecommerceConnection.org_ID]) ? organizationService.objectsById['' + row.ecommerceConnection.org_ID].name : '' }}</div>
            </ng-template>

            <ng-template #orderTemplate let-row>
              <span><span *ngIf="showSymbolMeanings"><span i18n="@@Store Order Id">Store Order Id</span>:&nbsp;</span>{{ row.bookorder.simpleOrderId ? '' + row.bookorder.simpleOrderId + ' (' + row.remoteOrderId + ')' : row.remoteOrderId }}</span>
              <span class="secondary-info"><span *ngIf="showSymbolMeanings"><span i18n="@@Ecommerce Order Id">Ecommerce Order Id</span>:&nbsp;</span>{{ row.ID }}</span>
              <span *ngIf="row.order_ID" class="secondary-info"><span *ngIf="showSymbolMeanings"><span i18n="@@Order Id">Order Id</span>:&nbsp;</span>{{ row.order_ID }}</span>
              <!-- Shown only once fulfilments exist. getPrintNodeOrderIdsLabel() returns '' both for an absent array (old server) and for an empty one (definitely none), because neither has an id to print. Digits are left unlocalized to match the Ecommerce Order Id and Order Id lines above - localizing just this one would put two digit systems in the same cell. -->
              <span *ngIf="getPrintNodeOrderIdsLabel(row)" class="secondary-info"><span *ngIf="showSymbolMeanings"><span i18n="@@Print Node Order Id">Print Node Order Id</span>:&nbsp;</span>{{ getPrintNodeOrderIdsLabel(row) }}</span>
            </ng-template>

            <ng-template #dateTemplate let-row>
              <span><span *ngIf="showSymbolMeanings"><span i18n="@@Created">Created</span><span>: </span></span>{{ row.createdDate | date: 'MM/dd/yy' }}</span>
              <span *ngIf="Util.getDateTimestamp(row.dateStartedProduction) > 1667466497314" class="secondary-info"><span *ngIf="showSymbolMeanings"><span *ngIf="showSymbolMeanings" i18n="@@Production">Production</span><span>: </span></span>{{ row.dateStartedProduction | date: 'MM/dd/yy' }}</span>
              <!-- Guarded on the same epoch as Production above: an unset date arrives as 0 / 1970 and must not be drawn as a real shipping date. Server-side population of shippedTimestamp is requested in outbox/2026-09-13-ecommerce-order-shipped-rollup-fields.md - until that lands this line simply never renders. -->
              <span *ngIf="Util.getDateTimestamp(row.shippedTimestamp) > 1667466497314" class="secondary-info"><span *ngIf="showSymbolMeanings"><span i18n="@@Shipped">Shipped</span><span>: </span></span>{{ row.shippedTimestamp | date: 'MM/dd/yy' }}</span>
            </ng-template>

            <ng-template #statusTemplate let-row>
              <app-ecommerce-order-status-indicators [remoteOrderStateStatus]="row.remoteOrderStateStatus" [uniqueRemoteOrderIdStatus]="row.uniqueRemoteOrderIdStatus" [costVsRevenueStatus]="row.costVsRevenueStatus" [revenueStatus]="row.revenueStatus" [userHoldStatus]="row.userHoldStatus" [releaseStatus]="row.releaseStatus" [ecommerceOrderStatus]="row.ecommerceOrderStatus" [addressStatus]="row.addressStatus" [productStatus]="row.productStatus" [carrierServiceLevelStatus]="row.carrierServiceLevelStatus" [functionalStatus]="row.functionalStatus" [ignoreStatus]="row.ignoreStatus" [showSymbolMeanings]="showSymbolMeanings" [checkCostVsRevenue]="row.ecommerceConnection.checkCostVsRevenue"></app-ecommerce-order-status-indicators>
            </ng-template>

            <ng-template #customerTemplate let-row>
              <span i18n-title="@@Customer Name">{{ row.firstname ? row.firstname + ' ' : '' }}{{ row.lastname ? row.lastname : '' }}{{ row.company ? ' ' + row.company : '' }}</span>
              <span class="secondary-info">{{ row.address1 }}, {{ row.address2 ? row.address2 + ', ' : '' }}{{ row.city }}, {{ row.state }}, {{ row.postalcode }}, {{ row.country }}</span>
            </ng-template>

            <ng-template #itemsTemplate let-row>
              <ng-container *ngIf="row.bookorder?.items && row.bookorder?.items.length > 0">
                <table>
                  <tr>
                    <td><span  *ngIf="showSymbolMeanings" i18n="@@Qty">Qty</span></td>
                    <td><span  *ngIf="showSymbolMeanings" i18n="@@Id">Id</span></td>
                    <td *ngIf="hasItemSku(row)"><span *ngIf="showSymbolMeanings" i18n="stock keeping unit|The seller's own code for the item as it arrived from the ecommerce platform. A product identifier, not a quantity or a stock level. Column header in a dense table, so keep it short - the widely understood English abbreviation is acceptable where the locale uses it.@@SKU">SKU</span></td>
                    <td><span  *ngIf="showSymbolMeanings" i18n="@@Title">Title</span></td>
                  </tr>
                  <tr *ngFor="let item of row.bookorder.items" [style.color]="productService.objectsById['' + item['productId']] && item['quantity'] && item['productId'] ? 'darkgreen': 'orange'">
                    <ng-container>
                      <td>{{ item['quantity'] ? item['quantity'] : '' }}</td>
                      <td>{{ item['productId'] ? item['productId'] : '' }}</td>
                      <td *ngIf="hasItemSku(row)" class="skuCell">{{ item['sku'] ? item['sku'] : '' }}</td>
                      <td>{{ productService.objectsById['' + item['productId']] ? productService.objectsById['' + item['productId']].title : item['title'] }}</td>
                    </ng-container>
                  </tr>
                </table>
              </ng-container>
            </ng-template>

            <ng-template #revenueAndCostTemplate let-row>
              <table class="revenueAndCostTable">
                <tr span *ngIf="showSymbolMeanings">
                  <td></td>
                  <td><span i18n="@@Revenue">Revenue</span></td>
                  <td><span *ngIf="row.releaseStatus === 'SUCCESS' || row.releaseStatus === 'READY'" i18n="what we pay|Internal cost to produce or ship the item. Not the customer-facing Price. Confusing the two misreports margin.@@Cost">Cost</span></td>
                </tr>
                <tr>
                  <td *ngIf="showSymbolMeanings" i18n="@@Product">Product</td>
                  <td><span ><span>{{ row.productRevenue | currency }}</span></span></td>
                  <td><span *ngIf=" row.releaseStatus === 'SUCCESS' || row.releaseStatus === 'READY'">{{ row.productionCost | currency }}</span></td>
                </tr>
                <tr>
                  <td *ngIf="showSymbolMeanings" i18n="outbound delivery|Delivery of the order to the customer. Not Billing, and not the freight cost line.@@Shipping">Shipping</td>
                  <td><span ><span>{{ row.shippingRevenue | currency }}</span></span></td>
                  <td><span *ngIf=" row.releaseStatus === 'SUCCESS' || row.releaseStatus === 'READY'">{{ ( row.shippingCost + row.packingCost ) | currency }}</span></td>
                </tr>
                <tr>
                  <td *ngIf="showSymbolMeanings" i18n="@@Tax">Tax</td>
                  <td><span ><span>{{ row.taxRevenue | currency }}</span></span></td>
                  <td><span *ngIf=" row.releaseStatus === 'SUCCESS' || row.releaseStatus === 'READY'">{{ row.taxCost | currency }}</span></td>
                </tr>
                <tr>
                  <td *ngIf="showSymbolMeanings" i18n="grand total|The final amount including shipping, handling and tax. Must be distinguishable from Subtotal.@@Total">Total</td>
                  <td><span ><span>{{ (row.shippingRevenue + row.productRevenue + row.taxRevenue) | currency }}</span></span></td>
                  <td><span *ngIf=" row.releaseStatus === 'SUCCESS' || row.releaseStatus === 'READY'">{{ (row.productionCost + row.shippingCost + row.packingCost + row.taxCost) | currency }}</span></td>
                </tr>
              </table>
              <table class="revenueAndCostTable" *ngIf="(row.releaseStatus === 'SUCCESS' || row.releaseStatus === 'READY')">
                <tr>
                  <td *ngIf="showSymbolMeanings" i18n="@@Total Margin">Margin Total</td>
                  <td></td>
                  <td><span [style.color]="( ( row?.productRevenue + row?.shippingRevenue + row?.taxRevenue ) - ( row?.productionCost + row?.shippingCost + row?.taxCost ) ) > 0 ? 'green' : 'red' ">{{ ( ( row?.productRevenue + row?.shippingRevenue + row?.taxRevenue ) - ( row?.productionCost + row?.shippingCost + row?.taxCost ) ) | currency }}</span></td>
                </tr>
              </table>
            </ng-template>
            <ng-template #trackingTemplate let-row>
              <span>{{ row.shippingInfo }}</span>
              <a *ngFor="let track of getTrackingNumbers(row).slice(0, 3)" [href]="getTrackingLink(track)" target="_blank" rel="noopener noreferrer" i18n-title="@@Track Order">{{ track }}</a>
              <span *ngIf="hasMoreTrackingNumbers(row)">...</span>
              <!-- shipmentUpdateStatus is hidden while it is 'INITIAL' (nothing attempted yet), which is the state of almost every row. -->
              <span *ngIf="showShipmentUpdateStatus(row)" class="secondary-info shipmentUpdateStatus" [style.color]="getShipmentUpdateStatusColor(row)"><span *ngIf="showSymbolMeanings"><span i18n="the push of the completion and tracking numbers back to the ecommerce store|Status of notifying the remote store that the order shipped. Not the shipping carrier status.@@Shipment Update">Shipment Update</span>:&nbsp;</span>{{ row.shipmentUpdateStatus | languageString }}</span>
            </ng-template>

            <ng-template #detailsTemplate let-row>
              <button mat-icon-button (click)="showDetails(row)" i18n-title="@@viewOrderDetails">
                <mat-icon>visibility</mat-icon>
              </button>
            </ng-template>

            <ng-template #actionsTemplate let-row>
              <button *ngIf="row.ignoreStatus==='NOT_IGNORE' && row.releaseStatus === 'READY'" mat-icon-button (click)="release(row, $event.target)" i18n-title="@@Release Order">
                <mat-icon>send</mat-icon>
              </button>
              <!-- Only offered when every PrintNodeOrder on the order is SHIPPED -- resending earlier would push a completion message for goods still in production. -->
              <button *ngIf="canResendShipmentUpdate(row)" mat-icon-button (click)="resendShipmentUpdate(row, $event.target)" i18n-title="resend the completion and tracking numbers to the ecommerce store|Retries telling the remote store that this order shipped. Does not re-ship anything.@@Resend Shipment Update" title="Resend Shipment Update">
                <mat-icon>cloud_upload</mat-icon>
              </button>
              <ng-container *ngIf="row.releaseStatus !== 'SUCCESS'">
                <button *ngIf="row.ignoreStatus==='NOT_IGNORE' && row.userHoldStatus==='NO_HOLD'" mat-icon-button (click)="setUserHoldStatus(row, 'HOLD', $event.target)" i18n-title="@@Put on Hold">
                  <mat-icon>pause</mat-icon>
                </button>
                <button *ngIf="row.ignoreStatus==='NOT_IGNORE' && row.userHoldStatus==='HOLD'" mat-icon-button (click)="setUserHoldStatus(row, 'NO_HOLD', $event.target)" i18n-title="@@Put on Hold">
                  <mat-icon>resume</mat-icon>
                </button>
              </ng-container>

              <!--
                The ignore toggle is deliberately OUTSIDE the `releaseStatus !== 'SUCCESS'` guard.

                `ignoreStatus` is operator queue state, not order state: it only decides whether a
                row shows up in the working filters (NEED_ATTENTION / READY_TO_RELEASE / PROCESSING /
                RELEASED / ON_HOLD / ALL) or drops into IGNORED. It neither releases nor cancels
                anything. Hiding the toggle after a successful release meant a released order that
                still needed to be taken out of the queue -- a duplicate, a store-side cancellation,
                an order being handled by hand -- could never be ignored again, and an order ignored
                *before* release could never be un-ignored once released, i.e. it was stuck in the
                IGNORED filter with no way back.

                Cancelling the work that was already released is a SEPARATE action (the PrintNodeOrders
                have to be cancelled on their own); ignoring here only hides the row.
              -->
              <button *ngIf="row.ignoreStatus==='NOT_IGNORE'" mat-icon-button (click)="setIgnoretatus(row, 'IGNORE', $event.target)" i18n-title="@@Ignore this order">
                <mat-icon>cancel</mat-icon>
              </button>
              <button *ngIf="row.ignoreStatus==='IGNORE'" mat-icon-button (click)="setIgnoretatus(row, 'NOT_IGNORE', $event.target)" i18n-title="@@Cancel ignore this order">
                <mat-icon>check_circle</mat-icon>
              </button>

              <ng-container *ngIf="row.releaseStatus !== 'SUCCESS'">
                <button *ngIf="row.ignoreStatus==='NOT_IGNORE' && row.userHoldStatus==='NO_HOLD'" mat-icon-button (click)="compute(row, $event.target)" i18n-title="@@Compute">
                  <mat-icon>refresh</mat-icon>
                </button>
              </ng-container>
            </ng-template>

            <!-- Narrow screen version -- no table but stacked div elements -->
            <div class="stackedOrders" *ngIf="mobileQuery.matches">
              <div *ngFor="let row of dataSource.data" class="stackedOrder"  [style.background-color]="getRowBackgroundColor(row)">
                <div class="group" data-label="Ecommerce Order" i18n-data-label="@@Ecommerce Order">
                  <div class="content">
                    <ng-container *ngTemplateOutlet="ecommerceConnectionTemplate; context: { $implicit: row }"></ng-container>
                  </div>
                </div>
                <div class="group" data-label="Order" i18n-data-label="@@Order" [style.background-color]="row.uniqueRemoteOrderIdStatus === 'ERROR' ? 'red': ''">
                  <div class="content">
                    <ng-container *ngTemplateOutlet="orderTemplate; context: { $implicit: row }"></ng-container>
                  </div>
                </div>
                <div class="group" data-label="Date" i18n-data-label="@@Date">
                  <div class="content">
                    <ng-container *ngTemplateOutlet="dateTemplate; context: { $implicit: row }"></ng-container>
                  </div>
                </div>
                <div class="group" data-label="Status" i18n-data-label="@@Status">
                  <div class="content">
                    <ng-container *ngTemplateOutlet="statusTemplate; context: { $implicit: row }"></ng-container>
                  </div>
                </div>
                <div class="group" data-label="Customer" i18n-data-label="@@Customer" [style.background-color]="row.addressStatus === 'ERROR' ? 'red': ''">
                  <div class="content">
                    <ng-container *ngTemplateOutlet="customerTemplate; context: { $implicit: row }"></ng-container>
                  </div>
                </div>
                <div class="group" data-label="Items" i18n-data-label="@@Items" [style.background-color]="row.productStatus === 'ERROR' ? 'pink': ''">
                  <div class="content">
                    <ng-container *ngTemplateOutlet="itemsTemplate; context: { $implicit: row }"></ng-container>
                  </div>
                </div>
                <div class="group" data-label="Cost" i18n-data-label="what we pay|Internal cost to produce or ship the item. Not the customer-facing Price. Confusing the two misreports margin.@@Cost" [style.background-color]="row.costVsRevenueStatus === 'REVIEW' ? 'red': ''">
                  <div class="content">
                    <ng-container *ngTemplateOutlet="revenueAndCostTemplate; context: { $implicit: row }"></ng-container>
                  </div>
                </div>
                <div class="group tracking" data-label="Tracking" i18n-data-label="@@Tracking" [style.background-color]="row.carrierServiceLevelStatus === 'ERROR' ? 'red': ''">
                  <div class="content">
                    <ng-container *ngTemplateOutlet="trackingTemplate; context: { $implicit: row }"></ng-container>
                  </div>
                </div>
                <div class="group" data-label="Details" i18n-data-label="@@Details">
                  <div class="content">
                    <ng-container *ngTemplateOutlet="detailsTemplate; context: { $implicit: row }"></ng-container>
                  </div>
                </div>
<!--                <div class="group-wrapper">-->
<!--                  <div class="group" data-label="Date" i18n-data-label="@@Date">-->
<!--                    <div class="content">-->
<!--                      <ng-container *ngTemplateOutlet="xxxTemplate; context: { $implicit: row }"></ng-container>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  <div class="actions">-->
<!--                    <ng-container *ngTemplateOutlet="xxxTemplate; context: { $implicit: row }"></ng-container>-->
<!--                  </div>-->
<!--                </div>-->
                <div class="actions">
                  <ng-container *ngTemplateOutlet="actionsTemplate; context: { $implicit: row }"></ng-container>
                </div>

              </div>
            </div>

            <!-- Wide screen version -- use a table -->
            <div class="ordersTable" *ngIf="!mobileQuery.matches">
              <table mat-table [dataSource]="dataSource" class="full-width-table">
                <ng-container *ngIf="ecommerceConnections && ecommerceConnections.length > 1" matColumnDef="ecommerceConnection">
                  <th mat-header-cell *matHeaderCellDef class="sortable-header" (click)="toggleSort('ecommerceConnection')" i18n-title="@@Sort by this column" title="Sort by this column">
                    <span class="sort-header-content"><span i18n="@@Ecommerce Connection">Ecommerce Connection</span>
                      <ng-container *ngTemplateOutlet="sortIndicatorTemplate; context: { $implicit: 'ecommerceConnection' }"></ng-container>
                    </span>
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <div class="ecommerce-connection-cell">
                      <ng-container *ngTemplateOutlet="ecommerceConnectionTemplate; context: { $implicit: row }"></ng-container>
                    </div>
                  </td>
                </ng-container>

                <ng-container matColumnDef="order">
                  <th mat-header-cell *matHeaderCellDef class="sortable-header" (click)="toggleSort('order')" i18n-title="@@Sort by this column" title="Sort by this column">
                    <span class="sort-header-content"><span i18n="@@Order">Order</span>
                      <ng-container *ngTemplateOutlet="sortIndicatorTemplate; context: { $implicit: 'order' }"></ng-container>
                    </span>
                  </th>
                  <td mat-cell *matCellDef="let row" [style.background-color]="row.uniqueRemoteOrderIdStatus === 'ERROR' ? 'red': 'inherit'">
                    <div class="order-cell">
                      <ng-container *ngTemplateOutlet="orderTemplate; context: { $implicit: row }"></ng-container>
                    </div>
                  </td>
                </ng-container>

                <ng-container matColumnDef="date">
                  <th mat-header-cell *matHeaderCellDef class="sortable-header" (click)="toggleSort('date')" i18n-title="@@Sort by this column" title="Sort by this column">
                    <span class="sort-header-content"><span i18n="@@Date">Date</span>
                      <ng-container *ngTemplateOutlet="sortIndicatorTemplate; context: { $implicit: 'date' }"></ng-container>
                    </span>
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <div class="date-cell">
                      <ng-container *ngTemplateOutlet="dateTemplate; context: { $implicit: row }"></ng-container>
                    </div>
                  </td>
                </ng-container>

                <ng-container matColumnDef="customer">
                  <th mat-header-cell *matHeaderCellDef class="sortable-header" (click)="toggleSort('customer')" i18n-title="@@Sort by this column" title="Sort by this column">
                    <span class="sort-header-content"><span i18n="@@Customer">Customer</span>
                      <ng-container *ngTemplateOutlet="sortIndicatorTemplate; context: { $implicit: 'customer' }"></ng-container>
                    </span>
                  </th>
                  <td mat-cell *matCellDef="let row" [style.background-color]="row.addressStatus === 'ERROR' ? 'red': 'inherit'">
                    <div class="customer-cell">
                      <ng-container *ngTemplateOutlet="customerTemplate; context: { $implicit: row }"></ng-container>
                    </div>
                  </td>
                </ng-container>

                <ng-container matColumnDef="items">
                  <th mat-header-cell *matHeaderCellDef class="sortable-header" (click)="toggleSort('items')" i18n-title="@@Sort by this column" title="Sort by this column">
                    <span class="sort-header-content"><span i18n="@@Items">Items</span>
                      <ng-container *ngTemplateOutlet="sortIndicatorTemplate; context: { $implicit: 'items' }"></ng-container>
                    </span>
                  </th>
                  <td mat-cell *matCellDef="let row" [style.background-color]="row.productStatus === 'ERROR' ? 'red': 'inherit'">
                    <ng-container *ngTemplateOutlet="itemsTemplate; context: { $implicit: row }"></ng-container>
                  </td>
                </ng-container>

                <ng-container matColumnDef="revenueAndCost">
                  <th mat-header-cell *matHeaderCellDef class="sortable-header" (click)="toggleSort('revenueAndCost')" i18n-title="@@Sort by this column" title="Sort by this column">
                    <span class="sort-header-content"><span i18n="@@Revenue and Cost">Revenue and Cost</span>
                      <ng-container *ngTemplateOutlet="sortIndicatorTemplate; context: { $implicit: 'revenueAndCost' }"></ng-container>
                    </span>
                  </th>
                  <td mat-cell *matCellDef="let row" [style.background-color]="row.revenueStatus === 'ERROR' ? 'red': 'inherit'">
                    <ng-container *ngTemplateOutlet="revenueAndCostTemplate; context: { $implicit: row }"></ng-container>
                  </td>
                </ng-container>

<!--                <ng-container matColumnDef="totalCost">-->
<!--                  <th mat-header-cell *matHeaderCellDef i18n="what we pay|Internal cost to produce or ship the item. Not the customer-facing Price. Confusing the two misreports margin.@@Cost">Cost</th>-->
<!--                  <td mat-cell *matCellDef="let row" [style.background-color]="row.costVsRevenueStatus === 'REVIEW' ? 'red': 'inherit'">-->
<!--                    <ng-container *ngTemplateOutlet="totalCostTemplate; context: { $implicit: row }"></ng-container>-->
<!--                  </td>-->
<!--                </ng-container>-->

                <ng-container matColumnDef="tracking">
                  <th mat-header-cell *matHeaderCellDef class="sortable-header" (click)="toggleSort('tracking')" i18n-title="@@Sort by this column" title="Sort by this column">
                    <span class="sort-header-content"><span i18n="@@Tracking">Tracking</span>
                      <ng-container *ngTemplateOutlet="sortIndicatorTemplate; context: { $implicit: 'tracking' }"></ng-container>
                    </span>
                  </th>
                  <td mat-cell *matCellDef="let row" [style.background-color]="row.carrierServiceLevelStatus === 'ERROR' ? 'red': 'inherit'">
                    <div class="tracking-cell">
                      <ng-container *ngTemplateOutlet="trackingTemplate; context: { $implicit: row }"></ng-container>
                    </div>
                  </td>
                </ng-container>

                <ng-container matColumnDef="details">
                  <th mat-header-cell *matHeaderCellDef i18n="@@Details">Details</th>
                  <td mat-cell *matCellDef="let row">
                    <ng-container *ngTemplateOutlet="detailsTemplate; context: { $implicit: row }"></ng-container>
                  </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef i18n="@@Actions">Actions</th>
                  <td mat-cell *matCellDef="let row">
                    <ng-container *ngTemplateOutlet="actionsTemplate; context: { $implicit: row }"></ng-container>
                  </td>
                </ng-container>

                <ng-container matColumnDef="status">
                  <th mat-header-cell *matHeaderCellDef class="sortable-header" (click)="toggleSort('status')" i18n-title="@@Sort by this column" title="Sort by this column">
                    <span class="sort-header-content"><span i18n="@@Status">Status</span>
                      <ng-container *ngTemplateOutlet="sortIndicatorTemplate; context: { $implicit: 'status' }"></ng-container>
                    </span>
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <div class="status-cell">
                      <ng-container *ngTemplateOutlet="statusTemplate; context: { $implicit: row }"></ng-container>
                    </div>
                  </td>
                </ng-container>

<!--                <ng-container matColumnDef="releasestatus">-->
<!--                  <th mat-header-cell *matHeaderCellDef i18n="@@Release">Release</th>-->
<!--                  <td mat-cell *matCellDef="let row">-->
<!--                    <ng-container [ngSwitch]="row.releaseStatus">-->

<!--                      &lt;!&ndash; Case: INITIAL - The order is in its initial state &ndash;&gt;-->
<!--                      <span class="status-icon" *ngSwitchCase="'INITIAL'" title="Initial Status" i18n-title="@@InitialStatus">-->
<!--                        <mat-icon>hourglass_bottom</mat-icon> &lt;!&ndash; Icon for a starting or pending state &ndash;&gt;-->
<!--                        <span *ngIf="showSymbolMeanings" class="status-icon-label" i18n="@@InitialStatus">Initial</span>-->
<!--                      </span>-->

<!--                      &lt;!&ndash; Case: READY - Order has not been released but is ready to be released &ndash;&gt;-->
<!--                      <span class="status-icon" *ngSwitchCase="'READY'" title="Ready for Release" i18n-title="@@ReadyForRelease">-->
<!--                        <mat-icon>play_circle_outline</mat-icon> &lt;!&ndash; Icon suggesting readiness to start &ndash;&gt;-->
<!--                        <span *ngIf="showSymbolMeanings" class="status-icon-label" i18n="@@ReadyForRelease">Ready for Release</span>-->
<!--                      </span>-->

<!--                      &lt;!&ndash; Case: NOT_READY - Order has not been released but is ready to be released &ndash;&gt;-->
<!--                      <span class="status-icon" *ngSwitchCase="'NOT_READY'" title="Not Ready for Release" i18n-title="@@NotReadyForRelease">-->
<!--                        <mat-icon>search</mat-icon> &lt;!&ndash; Icon suggesting readiness to start &ndash;&gt;-->
<!--                        <span *ngIf="showSymbolMeanings" class="status-icon-label" i18n="@@NotReadyForRelease">Not Ready for Release</span>-->
<!--                      </span>-->

<!--                      &lt;!&ndash; Case: SUCCESS - Order has been successfully released &ndash;&gt;-->
<!--                      <span class="status-icon" *ngSwitchCase="'SUCCESS'" title="Successfully Released" i18n-title="@@SuccessfullyReleased">-->
<!--                        <mat-icon>check_circle</mat-icon> &lt;!&ndash; Icon for successful completion &ndash;&gt;-->
<!--                        <span *ngIf="showSymbolMeanings" class="status-icon-label" i18n="@@SuccessfullyReleased">Success</span>-->
<!--                      </span>-->

<!--                      &lt;!&ndash; Case: ERROR - A general error occurred &ndash;&gt;-->
<!--                      <span class="status-icon" *ngSwitchCase="'ERROR'" title="Error" i18n-title="@@Error">-->
<!--                        <mat-icon>error</mat-icon> &lt;!&ndash; Standard error icon &ndash;&gt;-->
<!--                        <span *ngIf="showSymbolMeanings" class="status-icon-label" i18n="@@Error">Error</span>-->
<!--                      </span>-->

<!--                      &lt;!&ndash; Case: IN_PROGRESS - The release process is currently underway &ndash;&gt;-->
<!--                      <span class="status-icon" *ngSwitchCase="'IN_PROGRESS'" title="In Progress" i18n-title="@@InProgress">-->
<!--                        <mat-icon>sync</mat-icon> &lt;!&ndash; Icon for ongoing process &ndash;&gt;-->
<!--                        <span *ngIf="showSymbolMeanings" class="status-icon-label" i18n="@@InProgress">In Progress</span>-->
<!--                      </span>-->

<!--                      &lt;!&ndash; Default Case: In case none of the above match (though all are explicitly handled here) &ndash;&gt;-->
<!--                      <span class="status-icon" *ngSwitchDefault title="Unknown Status" i18n-title="@@UnknownStatus">-->
<!--                        <mat-icon>help_outline</mat-icon> &lt;!&ndash; Generic icon for unhandled or unknown states &ndash;&gt;-->
<!--                        <span *ngIf="showSymbolMeanings" class="status-icon-label" i18n="@@UnknownStatus">Unknown</span>-->
<!--                      </span>-->
<!--                    </ng-container>-->
<!--                    <span class="status-icon" *ngIf="row.userHoldStatus === 'HOLD'" title="On Hold" i18n-title="@@On Hold">-->
<!--                      <mat-icon>pause</mat-icon>-->
<!--                      <span *ngIf="showSymbolMeanings" class="status-icon-label" i18n="@@On Hold">On Hold</span>-->
<!--                    </span>-->
<!--                  </td>-->
<!--                </ng-container>-->

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;" [style.background-color]="getRowBackgroundColor(row)"></tr>
              </table>

              <div *ngIf="!dataSource?.data?.length" class="no-data">
                <span i18n="@@No Orders Found">No orders found.</span>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="selectedEcommerceOrder" class="pageArea">
          <app-ecommerce-order-details [ecommerceOrder]="selectedEcommerceOrder" [narrowDisplay]="mobileQuery.matches" (editingOrder)="editingOrder = $event"></app-ecommerce-order-details>
        </div>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
